import React, { useState } from 'react'
import { useDispatch } from 'react-redux'
import { TRANSACTION_TABS } from 'constants/index'
import AllBets from './components/AllBets/index'
import HighRoller from './components/HighRoller/index'

const TABS = [
  { id: TRANSACTION_TABS.ALL_BETS, label: 'Casino Bets' },
  { id: TRANSACTION_TABS.HIGH_ROLLER, label: 'Sports Bets' },
  { id: 'race', label: 'Race Leaderboard' },
]

const TransactionsTable = () => {
  const [tab, setTab] = useState(TRANSACTION_TABS.ALL_BETS)

  return (
    <section className='stake-bets-section'>
      <div className='stake-bets-header'>
        <div className='stake-bets-tabs'>
          {TABS.map(t => (
            <button
              key={t.id}
              className={`stake-bets-tab${tab === t.id ? ' active' : ''}`}
              onClick={() => setTab(t.id)}
            >
              {t.label}
            </button>
          ))}
        </div>
      </div>
      <div className='tab-content'>
        {tab === TRANSACTION_TABS.ALL_BETS && <AllBets tab={tab} />}
        {tab === TRANSACTION_TABS.HIGH_ROLLER && (
          <div className='stake-bets-coming-soon'>Sports Bets coming soon</div>
        )}
        {tab === 'race' && (
          <div className='stake-bets-coming-soon'>Race Leaderboard coming soon</div>
        )}
      </div>
    </section>
  )
}

export default React.memo(TransactionsTable)
